<script lang="ts">
  import { link } from "svelte-spa-router";
  import active, { type ActiveOptions } from "svelte-spa-router/active";
  import { isEditActive } from "$src/application/main/mainTemplateStore";
  import * as Dialog from "$lib/components/ui/dialog/index.js";
  import { buttonVariants } from "$lib/components/ui/button";
  import { t } from "svelte-i18n";
  import { cn } from "$lib/utils";
  import { createEventDispatcher } from "svelte";

  export let href: string;
  export let activeOptions: ActiveOptions | undefined = undefined;
  let className: string | undefined = undefined;

  export { className as class };
  
  const dispatch = createEventDispatcher<{ click: MouseEvent }>();

  const handleClick = (event: MouseEvent) => {
    dispatch('click', event);
  };
</script>

{#if $isEditActive == false}
  <a
    use:link
    use:active={activeOptions}
    {href}
    class={className}
    on:click={handleClick}
  >
    <slot />
  </a>
{:else}
  <Dialog.Root>
    <Dialog.Trigger class="justify-normal">
      <div class={cn("text-muted-foreground", className)}>
        <slot />
      </div>
    </Dialog.Trigger>
    <Dialog.Content class="sm:max-w-[425px]">
      <Dialog.Header>
        <Dialog.Title>{$t("global.messages.editingInProgress")}</Dialog.Title>
        <Dialog.Description>
          {$t("global.messages.navigationDisabledWhileEditing")}
        </Dialog.Description>
      </Dialog.Header>
      <Dialog.Footer>
        <Dialog.Close class={buttonVariants({ variant: "default" })}>
          {$t("global.messages.ok")}
        </Dialog.Close>
      </Dialog.Footer>
    </Dialog.Content>
  </Dialog.Root>
{/if}
